import { IEntityState, IProjectChild } from '../entity';
import { schema } from 'normalizr';
import { screeningSchema } from '../screening/screening.entity';
import {
  ISession,
  SessionEntityKeys,
  sessionSchema,
} from '../session/session.entity';
import { studyDetailsSchema } from '../study-details/study-details.entity';
import {
  AnnotationsKey,
  OutcomeDataKey,
  ScreeningsKey,
  SessionsKey,
  StudiesKey,
  StudyDetailsKey,
} from '@core/state/entities/entity-name-map';
import {
  StudyBaseDto,
  StudySummaryDto,
} from '@core/services/api-client.generated';

export interface IStudy
  extends IProjectChild,
    Omit<StudySummaryDto, 'sessions' | 'screening'> {
  sessions: string[];
  screening: string;
}

export const riskOfBiasPdfStatus = {
  pdfNotFound: 'PdfNotFound',
  pdfNotConverted: 'PdfNotConverted',
  textFieldGenerated: 'TextFieldGenerated',
};
interface IStudyChildEntityStateMap {
  sessions: IEntityState<ISession>;
}
export type StudyChildKeys = keyof IStudyChildEntityStateMap;

export type StudyEntityKeys =
  | StudiesKey
  | ScreeningsKey
  | StudyDetailsKey
  | SessionEntityKeys;

export const studySchema = new schema.Entity('studies', {
  screening: screeningSchema,
  sessions: [sessionSchema],
  studyDetails: studyDetailsSchema,
});
